import { W as WuiLoader$1, d as defineCustomElement$1 } from './p-lnuA9A6c.js';

const WuiLoader = WuiLoader$1;
const defineCustomElement = defineCustomElement$1;

export { WuiLoader, defineCustomElement };
